<template>
  <div class="bookshelf-container">
    <div class="bookshelf-header-container pb-3 mb-3">
      <div class="d-flex align-center mb-3">
        <bookshelf-icon
          :size="$vuetify.breakpoint.xs ? 20 : 32"
          class="icon mr-3"
          color="var(--v-primary-base)"
        />
        <h1 class="bookshelf-header">
          {{ $t('bookshelf.bookshelf') }}
        </h1>
      </div>
      <p class="bookshelf-blurb mb-10">
        {{ $t("bookshelf.blurb") }}
      </p>
    </div>
    <div>
      <book-display
        :data="visibleBookshelfItems"
        :is-loading="bookshelfLoading"
        :error="bookshelfQueryError"
        :loading-items="loadingItemsCount"
        :pagination-enabled="false"
        :show-owned="true"
      />
      <empty-book-list v-if="!bookshelfLoading && visibleBookshelfItems.length === 0" />
    </div>
  </div>
</template>

<script>
  import BookshelfIcon from "@/components/icons/BookshelfIcon";
  import EmptyBookList from "@/components/EmptyBookList";
  import BookDisplay from "@/components/BookDisplay";
  import BookQueries from "@/graphql/BookQueries";
  import CurrentCartOrderMixin from "@/mixins/CurrentCartOrderMixin";
  import { FORMATS } from "@/utils/Const";
  import { filterOwnedBookshelfItems } from "@/utils/bookshelfOwnership.mjs";
  import { normalizeResourceId } from "@/utils/GeneralFunctions";

  export default {
    name: "BookshelfItems",
    components: {
      BookshelfIcon,
      EmptyBookList,
      BookDisplay,
    },
    mixins: [CurrentCartOrderMixin],
    apollo: {
      bookshelfData: {
        query() {
          return BookQueries.getUserBookshelf;
        },
        update(data) {
          return data;
        },
        error(error) {
          this.bookshelfQueryError = error;
        },
        loadingKey: "bookshelfQueryLoading",
      },
    },
    data() {
      return {
        loadingItemsCount: 6,
        bookshelfData: null,
        bookshelfQueryLoading: 0,
        bookshelfQueryError: null,
      };
    },
    computed: {
      visibleBookshelfItems() {
        const seen = new Set();
        const items = (this.bookshelfData?.books?.collection || []).filter((book) => {
          if (book.format === FORMATS.print) return false;
          const id = normalizeResourceId(book.id);
          if (!id || seen.has(id)) return false;
          seen.add(id);
          return true;
        });

        if (this.currentCartId && !this.currentCartOrderReady) {
          return [];
        }

        return filterOwnedBookshelfItems(items, this.currentCartOrder);
      },
      bookshelfLoading() {
        return Boolean(this.bookshelfQueryLoading) ||
          Boolean(this.currentCartId && !this.currentCartOrderResolved);
      },
    },
  };
</script>

<style scoped>
  .bookshelf-header-container {
    border-bottom: 1px solid var(--v-lightAccent-base);
  }

  .bookshelf-header-container h1 {
    font-size: 2rem;
    font-weight: 500;
    align-self: flex-end;
    line-height: 1;
  }

  .bookshelf-header-container p {
    font-size: 1rem;
  }

  @media screen and (max-width: 599px) {
    .bookshelf-header-container h1 {
      font-size: 1.25rem;
    }

    .bookshelf-header-container p {
      font-size: 0.75rem;
    }
  }
</style>
